import { ContentCopy, Delete, PersonAddAlt1 } from "@mui/icons-material";
import React, { memo, useState } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

/**
 * Grava dados do fluxo no cadastro do contato.
 *
 * O que passa pelo fluxo some quando o atendimento acaba. O que fica aqui
 * aparece na ficha do cliente e no card do Kanban, e continua la depois.
 */
export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const [sobre, setSobre] = useState(false);

  const campos = Array.isArray(data?.campos) ? data.campos : [];

  return (
    <div
      onMouseEnter={() => setSobre(true)}
      onMouseLeave={() => setSobre(false)}
      style={{
        backgroundColor: "#ffffff",
        padding: "20px",
        borderRadius: "16px",
        minWidth: "250px",
        maxWidth: "250px",
        width: "250px",
        boxSizing: "border-box",
        position: "relative",
        fontFamily: "'Inter', sans-serif",
        border: "2px solid #e5e7eb",
        boxShadow: sobre ? "0 12px 32px rgba(0,0,0,0.12)" : "0 4px 16px rgba(0,0,0,0.06)",
        transition: "all 0.2s cubic-bezier(0.4,0,0.2,1)",
        transform: sobre ? "translateY(-2px)" : "translateY(0px)",
        userSelect: "none"
      }}
    >
      {sobre && (
        <div style={{ position: "absolute", top: "-14px", right: "8px", display: "flex", gap: "6px", zIndex: 10 }}>
          <ContentCopy
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("duplicate");
            }}
            style={{ cursor: "pointer", fontSize: 18, color: "#64748b", background: "#fff", borderRadius: 6, padding: 3, boxShadow: "0 2px 6px rgba(0,0,0,.15)" }}
          />
          <Delete
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("delete");
            }}
            style={{ cursor: "pointer", fontSize: 18, color: "#ef4444", background: "#fff", borderRadius: 6, padding: 3, boxShadow: "0 2px 6px rgba(0,0,0,.15)" }}
          />
        </div>
      )}

      <Handle
        type="target"
        position="left"
        isConnectable={isConnectable}
        style={{ background: "linear-gradient(135deg, #f59e0b, #b45309)", width: 16, height: 16, top: 24, left: -10, border: "2px solid #fff" }}
      />

      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
        <div style={{ width: 34, height: 34, borderRadius: 10, background: "linear-gradient(135deg, #f59e0b, #b45309)", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <PersonAddAlt1 style={{ color: "#fff", fontSize: 19 }} />
        </div>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>Salvar no contato</div>
          <div style={{ fontSize: 11, color: "#64748b" }}>Fica na ficha do cliente</div>
        </div>
      </div>

      {campos.length === 0 ? (
        <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "8px 10px", fontSize: 11.5, color: "#b91c1c", fontWeight: 600 }}>
          Nenhum campo escolhido
        </div>
      ) : (
        <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "8px 10px" }}>
          {campos.slice(0, 4).map((c, i) => (
            <div key={i} style={{ fontSize: 11.5, color: "#92400e", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              <strong>{c.nome}</strong>: {c.valor}
            </div>
          ))}
          {campos.length > 4 && (
            <div style={{ fontSize: 10.5, color: "#b45309", marginTop: 2 }}>
              +{campos.length - 4} campo(s)
            </div>
          )}
        </div>
      )}

      <Handle
        type="source"
        position="right"
        id="a"
        isConnectable={isConnectable}
        style={{ background: "linear-gradient(135deg, #f59e0b, #b45309)", width: 16, height: 16, right: -10, border: "2px solid #fff" }}
      />
    </div>
  );
});
